export default __webpack_public_path__ + "static/media/PauseIcon.edc22fb6.svg";